import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'

import api from '../../../services/api'

import VisualizeRender from './VisualizeRender'

export default function Visualize ({ id }) {
  const [inputs, setInputs] = useState({})
  const [getCities, setCities] = useState([])
  const [getEstados, setEstados] = useState([])
  const [getJornadas, setJornadas] = useState([])
  const [getLoading, setLoading] = useState(true)

  useEffect(() => {
    visualizeColab()
  }, [])

  const visualizeColab = async () => {
    try {
      const response = await api.get(`Colaboradores/ConsultarId?id=${id}`)
      setInputs(response.data.resposta)

      const searchStates = await api.get('Estados/Consultar')
      setEstados(searchStates.data.resposta)

      const responseCities = await api.get('Municipios/Consultar')
      setCities(responseCities.data.resposta)

      const searchJornadas = await api.get('JornadasTrabalhos/Consultar')
      setJornadas(searchJornadas.data.resposta)
    } catch (err) {
      toast.error('Não foi possível obter os dados do colaborador!')
    }
    setLoading(false)
  }
  return (
  <VisualizeRender
    inputs={inputs}
    getCities={getCities}
    getEstados={getEstados}
    getJornadas={getJornadas}
    getLoading={getLoading}
  />)
}
